import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import {
  readDomainsForFlow,
  readSegmentsForFlow,
  readTagsForPins,
} from 'next/lib/selectors';
import { openExperience } from 'next/lib/builder';
import { Shape as PinShape } from 'next/entities/experiences';
import { update } from 'next/entities/pins';
import useToggle from 'next/hooks/use-toggle';
import { Experience, Metric } from 'next/components/Listing';
import { OpenInBuilderManager } from 'next/components/OpenInBuilder';
import { EditTagsModal } from 'next/components/Tags';
import Actions from './Actions';

export function PinCard({ domains, pin, segments, tags, view, updatePin }) {
  const { id, previewUrl, state, steps } = pin;

  const [editingTags, toggleEditingTags] = useToggle();
  const [openBuilder, toggleOpenBuilder] = useToggle();

  const handleOpenInBuilder = useCallback(() => {
    openExperience({ experience: id, url: previewUrl });
  }, [id, previewUrl]);

  // TODO: Consider abstracting as separate component e.g. PinMetrics
  const metric = useMemo(() => {
    const label = `${steps?.length || 0} pins`;
    return <Metric icon="thumbtack" label={label} />;
  }, [steps]);

  const handleTagsUpdate = tagIds => {
    updatePin(id, { tagIds });
  };

  return (
    <>
      <Experience
        actions={
          <Actions
            archived={state === 'ARCHIVED'}
            pinId={id}
            onOpenBuilder={toggleOpenBuilder}
            onOpenEditTags={toggleEditingTags}
          />
        }
        experience={pin}
        domains={domains}
        metric={metric}
        segments={segments}
        tags={tags}
        type="pins"
        view={view}
      />

      <OpenInBuilderManager
        onClose={toggleOpenBuilder}
        onNavigate={handleOpenInBuilder}
        type="pins"
        visible={openBuilder}
      />
      <EditTagsModal
        tags={tags?.data}
        onClose={toggleEditingTags}
        visible={editingTags}
        label={pin.name}
        onChange={handleTagsUpdate}
      />
    </>
  );
}

PinCard.propTypes = {
  ...Experience.propTypes,
  pin: PinShape,
};

const mapDispatchToProps = dispatch => ({
  updatePin: (id, delta) => dispatch(update(id, delta)),
});

const mapStateToProps = (state, { pin }) => ({
  domains: readDomainsForFlow(state, pin.id),
  segments: readSegmentsForFlow(state, pin.id),
  tags: readTagsForPins(state, pin.id),
});

export default connect(mapStateToProps, mapDispatchToProps)(PinCard);
